import {Platform} from 'react-native';
import {APP_VERSION} from '../config/version';

export function getDeviceInfo(): string | undefined {
  if (Platform.OS === 'web') {
    return undefined;
  }
  return `Oma App ${APP_VERSION} on Android ${Platform.Version}`;
}
